import { compose } from 'recompose'
import {
  connectDataFetched,
  makesMutations,
  extraDataFromResultAndDispatch,
} from 'data/graphql'
import NotificationsAPI from 'remote/notifications'

export default ({ mutationPropName = 'acknowledgeAllNotifications' } = {}) => {
  return compose(
    connectDataFetched,
    makesMutations({
      query: NotificationsAPI.acknowledgeAllNotifications,
      mutationPropName,
      getOnResultFromProps: extraDataFromResultAndDispatch(
        'acknowledgeAllNotifications'
      ),
    })
  )
}
